import {makeAutoObservable} from 'mobx'
import {SortOrder} from '../../types/SortOrder'
import {StoriesListFilters} from '../../types/story/StoriesListFilters'
import {defaultFilters} from './storiesListStore.defaultValues'
import IStoriesListStore from './storiesListStore.types'

class StoriesListStore implements IStoriesListStore {
  filters: StoriesListFilters = defaultFilters
  loadingData = false
  sortFieldName = 'publishedAtDate'
  sortDirection: SortOrder = SortOrder.Desc
  isEmptyList = false
  processedRowsCount = 0

  constructor() {
    makeAutoObservable(this)
  }

  setFilters = (value: StoriesListFilters): void => {
    this.filters = value
  }

  setFiltersWithPrevState = (cb: (prev: StoriesListFilters) => StoriesListFilters): void => {
    this.filters = cb(this.filters)
  }

  setLoadingData = (value: boolean): void => {
    this.loadingData = value
  }

  setIsEmptyList = (value: boolean): void => {
    this.isEmptyList = value
  }

  setSortFieldName = (value: string): void => {
    this.sortFieldName = value
  }

  setSortDirection = (value: SortOrder): void => {
    this.sortDirection = value
  }

  reset = (): void => {
    this.filters = defaultFilters
    this.loadingData = false
    this.sortFieldName = 'publishedAtDate'
    this.sortDirection = SortOrder.Desc
    this.isEmptyList = false
    this.processedRowsCount = 0
  }
}

export default StoriesListStore
